<app-ace-select
  bindLabel="name"
  bindValue="impact_id"
  [appendTo]="appendTo"
  [formControl]="formControl"
  [hideSelected]="false"
  [isReadOnly]="isReadOnly"
  [items]="impacts"
  [loading]="loading"
  [multiSelect]="multiSelect"
  [placeholder]="placeholder"
  [closeOnSelect]="!multiSelect"
  [maxSelectedLabels]="maxSelectedLabels"
  [maxSelectedShowItemName]="maxSelectedShowItemName"
  [maxSelectedItemName]="maxSelectedItemName"
  [truncateLabels]="truncateLabels"
  [clearable]="clearable"/>